import Select from 'react-select'
import strings from '../../res/strings'
import dropdownStyles from './dropdownStyles'
import dropdownStylesError from './dropdownStylesError'

const DropdownInput = (props) => {
    return (
        <Select
            className='mt-1.5 font-montserrat'
            styles={props.error ? dropdownStylesError : dropdownStyles}
            options={props.options}
            value={props.value}
            onChange={props.onChange}
            placeholder={strings.select}
            isDisabled={props.disabled}
            noOptionsMessage={() => strings.noOptions}
        />
    )
}

export default DropdownInput